import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetTravelShorcutsCommand extends IRequestCommand<
IGetTravelShortcutsResponse,
  ErrorDetails,
  IGetTravelShortcutsParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/shortcuts'

  public override setParameters(parameters: IGetTravelShortcutsParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.idCarrier ? parameters.idCarrier.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface IGetTravelShortcutsParameters {
  idCarrier: number;
}

export interface IGetTravelShortcutsResponse extends ICommandResponse {
}
